<script>
import NavBar from '@components/nav-bar'
import FooterBar from '@components/footer-bar'
import SideBar from '@components/side-bar'
import RightBar from '@components/right-bar'

export default {
  components: { NavBar, FooterBar, SideBar, RightBar },
  data() {
    return {
      isMenuCondensed: false,
      user: this.$store ? this.$store.state.auth.currentSession.user : {} || {},
    }
  },
  watch: {
    isMenuCondensed(newVal, oldVal) {
      localStorage.setItem('isMenuCondensed', newVal);
    }
  },
  created: () => {
    document.body.style.backgroundColor = '';
    document.body.classList.remove('authentication-bg')
    document.body.classList.remove('authentication-bg-pattern')
  },
  methods: {
    toggleMenu() {
      this.isMenuCondensed = !this.isMenuCondensed
      document.body.classList.toggle('sidebar-enable')
      // if (
      //   !/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini|Mobile|mobile|CriOS/i.test(
      //     navigator.userAgent
      //   )
      // )
      document.body.classList.toggle('enlarged')
    },
    toggleRightSidebar() {
      document.body.classList.toggle('right-bar-enabled')
    },
    toggleDarkMode(mode) {
      document.documentElement.classList.toggle('dark', mode !== null ? mode : document.documentElement.classList.contains('dark'));
    }
  }
  // mounted: function(){
    // this.toggleMenu()
    // if (localStorage.getItem('isMenuCondensed') === 'true'){
    //   this.toggleMenu()
    // }
  // }
}
</script>

<template>
  <div id="wrapper">
    <NavBar :user="user" />
    <SideBar :is-condensed="isMenuCondensed" />
    <!-- ============================================================== -->
    <!-- Start Page Content here -->
    <!-- ============================================================== -->

    <div class="content-page">
      <div class="content">
        <!-- Start Content-->
        <div class="container-fluid p-1">
          <slot />
        </div>
      </div>
    </div>
    <FooterBar class="d-none" />
  </div>
</template>
